import { render, staticRenderFns } from "./LandingAlert.vue?vue&type=template&id=492d89de&scoped=true"
import script from "./LandingAlert.vue?vue&type=script&lang=js"
export * from "./LandingAlert.vue?vue&type=script&lang=js"
import style0 from "./LandingAlert.vue?vue&type=style&index=0&id=492d89de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d89de",
  null
  
)

export default component.exports